import * as api from './../api/api.service';
// UX I added navDownloadBtn to replace navDownload I think this cna be removed and is not used anymore
export default function NavDownloadDirective() {
  class NavDownloadController {

    isNewDownload: boolean;

    constructor(private FileDownloadService,
      private api: api.IApiService) {
      'ngInject';
    }
    // Trigger on click of the download button, makes a call to FileDownloadService to get the file.
    downloadRequest(url, fileName) {
      let filePromise = this.FileDownloadService.downloadFile(url, fileName);
      return filePromise;
    }

    getDownload(url, fileName, planId, rfpId, filters) {
      if (this.isNewDownload) {
        return this.api.purchasePlans.getDownloadPlanUrl(planId, rfpId, filters).then(data =>
          this.FileDownloadService.downloadFile(data.url, fileName)
        );
      } else {
        return this.downloadRequest(url, fileName)
      }
    }
  }
  return {
    controllerAs: '$ctrl',
    controller: NavDownloadController,
    bindToController: true,
    scope: {
      url: '=',
      disabled: '=',
      fileName: '<',
      isNewDownload: '=',
      planId: '=',
      rfpId: '=',
      filters: '='
    },
    restrict: 'E',
    template: `<a class="btn btn-default btn-sm"
                ng-disabled="$ctrl.disabled"
                target="_self"
                ng-click="filePromise = $ctrl.getDownload($ctrl.url, $ctrl.fileName, $ctrl.planId, $ctrl.rfpId, $ctrl.filters)"
                apt-loading-indicator
                apt-loading-indicator-class="apt-loading-indicator-backdrop-contextual"
                apt-loading-indicator-message="Loading"
                apt-loading-indicator-promise="filePromise">
                <i class="apt-download-icon"></i> Download
              </a>
              `
  };
}
